import { render } from "./InviteCodesView.vue?vue&type=template&id=0b1bea75&scoped=true"
import script from "./InviteCodesView.vue?vue&type=script&lang=js"
export * from "./InviteCodesView.vue?vue&type=script&lang=js"

import "./InviteCodesView.vue?vue&type=style&index=0&id=0b1bea75&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1bea75"]])

export default __exports__